// extracted by mini-css-extract-plugin
export default {"Testimonials":"Testimonials_Testimonials__WZIry","Testtitle":"Testimonials_Testtitle__I73Gb"};